<button
  type="button"
  class="chat-indicator"
  [class.chat-indicator--active]="newMessages() > 0"
  [attr.aria-label]="'nav.chat' | translate"
  (click)="gotoChat()"
>
  <ut-icon name="message-circle" [size]="20"></ut-icon>
  @if (newMessages() > 0) {
    <span class="chat-indicator__badge" aria-hidden="true">
      {{ badgeLabel() }}
    </span>
  }
</button>
